import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetAuthorArticlesAppendSucceed, EGetAuthorArticlesActionType } from './types';
import { IAuthorArticles } from '../../../types/authorArticles';

export const getAuthorArticlesAppendSucceed: (data: IAuthorArticles) => TGetAuthorArticlesAppendSucceed =
  actionGenerator<EGetAuthorArticlesActionType.AppendSucceed, IAuthorArticles>(
    EGetAuthorArticlesActionType.AppendSucceed,
  );
